module.exports = __webpack_public_path__ + "img/SC6-Future_income_needs.e499d667.png";